import { core } from '../core';
export var Box = core.div;
export var BaseView = Box;
export var View = Box;